/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { interval, Observable, Subscription } from 'rxjs';

@Injectable()
export class CoachActionService {
  private action: any;
  private coachActionInterval: Subscription;
  private coachActionTimeout: any;
  private isCoachActionPinging = false;

  constructor(private httpClient: HttpClient) {}

  pingAction(action: any): Observable<any> {
    return this.handleResponse(this.httpClient.post(`${environment.apiHostname}/v1/coach-action/ping`, action));
  }

  clearActionInterval() {
    this.coachActionInterval?.unsubscribe();
  }

  setAction(action) {
    this.action = action;
  }

  pingCoachAction(intervalValue, ignoreInterval = false) {
    this.coachActionInterval?.unsubscribe();
    this.isCoachActionPinging = true;
    const t0 = performance.now();
    return this.pingAction(this.action).pipe(
      tap((resultAction) => {
        if (ignoreInterval) {
          return;
        }
        const t1 = (performance.now() - t0) / 1000;
        this.coachActionInterval = interval(intervalValue)
          .pipe(
            tap((timer) => {
              this.pingAction({ ...resultAction, duration: (timer + 1) * 5 + t1 }).subscribe();
            })
          )
          .subscribe();
        this.isCoachActionPinging = false;
        this.setPingTimeout();
      })
    );
  }

  setPingTimeout() {
    // After 15 mins of inactivity, the user is considered away from the page
    const TIMEOUT_VALUE = 900000;

    if (this.coachActionTimeout) {
      clearTimeout(this.coachActionTimeout);
    }
    this.coachActionTimeout = setTimeout(() => {
      this.coachActionInterval?.unsubscribe();
    }, TIMEOUT_VALUE);
  }

  handlePageRevisit(pingInterval) {
    // Ping new action when revisiting page
    if (this.coachActionInterval?.closed && !this.isCoachActionPinging) {
      this.pingCoachAction(pingInterval).subscribe();
      return;
    }
    this.setPingTimeout();
  }

  private handleResponse(methodCallResponse: Observable<object>) {
    return methodCallResponse.pipe(
      map((response: any) => {
        if (response.result.success) {
          return response.data;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }
}
